module.exports = __webpack_public_path__ + "img/41b7cc5.png";